import React from 'react';
import { useTranslation } from 'react-i18next';
import BeamsBackground from './micro/BeamsBackground';
import '../styles/hero.scss';
import star from '../assets/images/star.png';

const Hero = () => {
  const { t } = useTranslation();

  const stats = [
    { value: t('hero.stat1_value'), text: t('hero.stat1_text') },
    { value: t('hero.stat2_value'), text: t('hero.stat2_text') },
    { value: t('hero.stat3_value'), text: t('hero.stat3_text') },
  ];

  return (
    <section className="hero">
      <div className="hero__background">
        <BeamsBackground
          beamWidth={2.4}
          beamHeight={18}
          beamNumber={18}
          lightColor="#f5f5f5"
          speed={2.4}
          noiseIntensity={1.35}
          scale={0.18}
          rotation={-12}
        />
        <div className="hero__mask" />
        <div className="hero__gradient" />
      </div>
      <div className="hero__content">
        <p className="hero__eyebrow">{t('hero.eyebrow')}</p>
        <h1>
          {t('hero.title').split('\n').map((line, index, array) => (
            <React.Fragment key={index}>
              {line}
              {index < array.length - 1 && <br />}
            </React.Fragment>
          ))}
        </h1>
        <p className="hero__description">
          {t('hero.description')}
        </p>
        <div className="hero__cta">
          <a className="btn btn--primary" href="/contact">
            <span className="btn__icon">
              <img src={star} alt="" />
            </span>
            <span>{t('hero.cta_primary')}</span>
          </a>
          <a className="btn btn--ghost" href="/portfolio">{t('hero.cta_secondary')}</a>
        </div>
        <div className="hero__stats">
          {stats.map((stat) => (
            <div key={stat.value}>
              <span>{stat.value}</span>
              <p>{stat.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
